import './../style.scss'
export default {
    computed: {
        // 销毁计划状态
        statusList () {
            return [{
                label: '草稿',
                value: 0,
                theme: 'normal'
            }, {
                label: '待审核',
                value: 1,
                theme: 'warning'
            }, {
                label: '待销毁',
                value: 2,
                theme: 'primary'
            }, {
                label: '审核拒回',
                value: 3,
                theme: 'error'
            }, {
                label: '销毁中',
                value: 4,
                theme: 'primary'
            }, {
                label: '已完成',
                value: 5,
                theme: 'success'
            }, {
                label: '已取消',
                value: 10,
                theme: 'error'
            }]
        },
        // 销毁计划操作类型
        operateTypeList () {
            return [{
                label: '创建',
                value: 0,
            }, {
                label: '更新',
                value: 1
            }, {
                label: '提交',
                value: 2
            }, {
                label: '撤销审核',
                value: 3
            }, {
                label: '审核通过',
                value: 4
            }, {
                label: '审核拒回',
                value: 6
            }, {
                label: '完成',
                value: 5
            }, {
                label: '取消',
                value: 10
            }, {
                label: '推送仓库',
                value: 11
            }]
        },
        // 库存类型
        stockTypeList () {
            return [{
                value: 0,
                label: '可售库存',
            }, {
                value: 1,
                label: '不可售库存'
            }]
        },
    }
}